import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import StarIcon from "@mui/icons-material/Star";
import SellIcon from "@mui/icons-material/Sell";
import PrintIcon from "@mui/icons-material/Print";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import DownloadIcon from "@mui/icons-material/Download";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import AssignmentReturnedIcon from "@mui/icons-material/AssignmentReturned";
import useItem from "../../services/queries/useItem";
import useUser from "../../services/queries/useUser";
import useKategori from "../../services/queries/useKategori";
import ModalStok from "../../components/ModalStok/ModalStok";
import ModalMutasiStok from "../../components/ModalMutasiStok/ModalMutasiStok";
import ModalDetailBarang from "../../components/ModalDetailBarang/ModalDetailBarang";
import avatarAlt from "../../utils/avatarAlt";
import { useAuth } from "../../context/authContext";
import { useTransaksi } from "../../context/transaksiContext";
import { useStokModal } from "../../context/stokModalContext";
import { useImportModal } from "../../context/importModalContext";
import { useKatalogModal } from "../../context/katalogModalContext";
import { useKategoriModal } from "../../context/kategoriModalContext";
import { useHapusStokModal } from "../../context/hapusStokModalContext";
import { useMutasiStokModal } from "../../context/mutasiStokModalContext";
import { usePrintBarcodeModal } from "../../context/printBarcodeModal";
import {
    ContentGetItemResponse,
    IOptions,
    ParamsGetItem,
    ParamsGetKategori,
} from "../../constants/types";
import { ReactComponent as BarangTidakDitemukan } from "../../assets/images/BarangTidakDitemukan.svg";
import Spinner from "../Spinner/Spinner";
import NoRowsImage from "../NoRowsImage/NoRowsImage";
import LoadingTabel from "../LoadingTabel/LoadingTabel";
import CardStokBarang from "../CardStokBarang/CardStokBarang";
import ModalDeleteStok from "../ModalDeleteStok/ModalDeleteStok";
import Autocomplete from "@mui/material/Autocomplete";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import truncate from "../../utils/truncate";
import toRibuan from "../../utils/toRibuan";
import qs from "query-string";
import axios from "../../services/axios";
import toRupiahDesimal from "../../utils/toRupiahDesimal";
import Tooltip from "@mui/material/Tooltip";
import ModalDetailHarga from "../../components/ModalDetailHarga/ModalDetailHarga";
import Badge from "@mui/material/Badge";
import { LoadingButton } from "@mui/lab";
import ModalImportHarga from "../ModalImportHarga/ModalImportHarga";

interface ITabelBarangProps {}

const TabelBarang = (props: ITabelBarangProps) => {
    const theme = useTheme();
    const { ukmIdUser } = useAuth();
    const { openModalPrintBarcode } = usePrintBarcodeModal();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.between("xs", "sm"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const isLaptopScreen = useMediaQuery(theme.breakpoints.up("md"));
    // const isDesktopScreen = useMediaQuery(theme.breakpoints.up("xl"));

    const initialParamsItem = {
        ukmId: ukmIdUser && ukmIdUser[0],
        size: 10,
        page: 1,
        search: "",
        kategori: "",
    };
    const [paramsItem, setParamsItem] =
        useState<ParamsGetItem>(initialParamsItem);
    const {
        data: dataItem,
        refetch: refetchItem,
        isLoading: isLoadingItem,
    } = useItem(paramsItem);

    const initialParamsKategori = {
        ukmId: Number(ukmIdUser && ukmIdUser[0]),
        size: 500,
        page: 1,
        search: "",
    };
    const [paramsKategori, setParamsKategori] = useState<ParamsGetKategori>(
        initialParamsKategori,
    );
    const {
        status: statusKategori,
        data: dataKategori,
        refetch: refetchKategori,
    } = useKategori(paramsKategori);
    const { data: user } = useUser();
    const [selectedKategori, setSelectedKategori] = useState<IOptions | null>(
        null,
    );
    const [isOpenModalDetailHarga, setIsOpenModalDetailHarga] =
        React.useState(false);
    const [isOpenModalImportHarga, setIsOpenModalImportHarga] =
        React.useState(false);
    const [isLoadingButton, setIsLoadingButton] = React.useState(false);

    const initialSelectedBarang = {
        id: 0,
        nomer: 0,
        namaBarang: "",
        deskripsi: "",
        sku: "",
        kategori: {
            id: 0,
            nama: "",
        },
        gambar: "",
        harga: 0,
        isActiveStok: false,
        favorite: 0,
        terjual: 0,
        stok: 0,
        isBundling: 0,
        itemSatuan: null,
        detailBundling: [],
        multipleHarga: [],
        hpp: [],
        profit: 0,
        tipe: null,
        dppTerakhir: "",
    };
    const [selectedBarang, setSelectedBarang] =
        React.useState<ContentGetItemResponse>(initialSelectedBarang);

    const openModalDetailHarga = (data: ContentGetItemResponse) => {
        setSelectedBarang(data);
        setIsOpenModalDetailHarga(true);
    };
    const closeModalDetailHarga = () => setIsOpenModalDetailHarga(false);

    const closeModalImportHarga = () => setIsOpenModalImportHarga(false);
    const openModalImportHarga = () => setIsOpenModalImportHarga(true);

    const { isFetchingItems, cancelFetchingItems } = useTransaksi();

    const { openModal } = useStokModal();
    const { openModalImport } = useImportModal();
    const { openModalKatalog } = useKatalogModal();
    const { openModalKategori } = useKategoriModal();
    const { openModalHapusStok } = useHapusStokModal();
    const { openModalMutasiStok } = useMutasiStokModal();

    const [search, setSearch] = useState("");

    const downloadExportStok = async () => {
        setIsLoadingButton(true);
        try {
            const apiGetExportStok = qs.stringifyUrl({
                url: "api/exportstok",
            });
            const { data } = await axios.get(apiGetExportStok, {
                responseType: "blob",
            });
            if (data) {
                const file = new Blob([data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
                });
                const fileURL = URL.createObjectURL(file);
                const link = document.createElement("a");
                link.href = fileURL;
                link.setAttribute("download", `Export_Stok_Kikomart`); //or any other extension
                document.body.appendChild(link);
                link.click();
                setIsLoadingButton(false);
            }
        } catch (error) {
            console.error(error);
            setIsLoadingButton(false);
        }
    };

    const columns: GridColDef[] = [
        {
            field: "namaBarang",
            headerName: "Info Barang (Terjual)",
            flex: isLaptopScreen ? 1.5 : undefined,
            minWidth: 320,
            valueGetter: (params) => params.value,
            renderCell: (params) => {
                return (
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Badge
                            overlap="circular"
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "right",
                            }}
                            badgeContent={
                                params.row.favorite > 0 ? (
                                    <StarIcon
                                        sx={{
                                            position: "relative",
                                            border: 1,
                                            borderColor: "#e7e5e4",
                                            borderRadius: "50%",
                                            padding: 0.2,
                                            color: "#fbbf24",
                                            bgcolor: "#FFFFFF",
                                        }}
                                    />
                                ) : null
                            }
                        >
                            <Avatar
                                sx={{
                                    backgroundColor: "primary.main",
                                    width: 36,
                                    height: 39,
                                }}
                                variant="rounded"
                                alt={params.value}
                                src={params.row.gambar}
                            >
                                {avatarAlt(params.value)}
                            </Avatar>
                        </Badge>
                        <Stack direction="column" spacing={0.3}>
                            <Tooltip
                                title={`${params.value} ${
                                    params.row.terjual
                                        ? `(${params.row.terjual})`
                                        : "(0)"
                                }`}
                            >
                                <Typography
                                    component="div"
                                    variant="subtitle2"
                                    fontWeight="bold"
                                >
                                    {`${truncate(params.value, 27)} `}
                                    <Typography
                                        variant="subtitle2"
                                        display="inline"
                                    >
                                        {`${
                                            params.row.terjual
                                                ? `(${params.row.terjual})`
                                                : "(0)"
                                        }`}
                                    </Typography>
                                </Typography>
                            </Tooltip>
                            <Tooltip
                                title={
                                    params.row.deskripsi === null
                                        ? " "
                                        : params.row.deskripsi
                                }
                            >
                                <Typography variant="caption">
                                    {params.row.deskripsi === null
                                        ? " "
                                        : truncate(params.row.deskripsi, 27)}
                                </Typography>
                            </Tooltip>
                        </Stack>
                    </Stack>
                );
            },
        },
        {
            field: "kategori",
            headerName: "Kategori",
            flex: isLaptopScreen ? 1 : undefined,
            minWidth: 160,
            valueGetter: (params) => params.row.kategori.nama,
            renderCell: (params) => {
                return (
                    <Tooltip title={params.row.kategori.nama}>
                        <span className="table-cell-trucate">
                            {params.row.kategori.nama}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "multipleHarga",
            headerName: "Harga",
            align: "right",
            flex: isLaptopScreen ? 1 : undefined,
            minWidth: 160,
            renderCell: (params) => {
                return (
                    <Tooltip title="Lihat detail harga">
                        <Button
                            variant="outlined"
                            size="small"
                            color="inherit"
                            onClick={() => {
                                openModalDetailHarga(params.row);
                            }}
                            sx={{ textTransform: "none" }}
                        >
                            {toRupiahDesimal(Number(params.value[0].harga))}
                        </Button>
                    </Tooltip>
                );
            },
        },
        {
            field: "stok",
            headerName: "Stok",
            flex: isLaptopScreen ? 1 : undefined,
            minWidth: 80,
            renderCell: (params) => {
                return (
                    <Box marginY={1}>
                        <Tooltip
                            title={
                                params.row.isBundling > 0
                                    ? "Otomatis"
                                    : params.value === null
                                    ? "Nonaktif"
                                    : params.value
                            }
                        >
                            <Typography
                                variant="subtitle2"
                                color={
                                    params.value < 5 && params.value !== null
                                        ? "#ef4444"
                                        : undefined
                                }
                                fontWeight={
                                    params.value < 5 && params.value !== null
                                        ? 700
                                        : "normal"
                                }
                            >
                                {params.row.isBundling > 0
                                    ? "Otomatis"
                                    : params.value === null
                                    ? "Nonaktif"
                                    : params.value}
                            </Typography>
                        </Tooltip>
                    </Box>
                );
            },
        },
        {
            field: "profit",
            headerName: "Profit",
            flex: isLaptopScreen ? 1 : undefined,
            minWidth: 120,
            renderCell: (params) => {
                return (
                    <Tooltip title={toRupiahDesimal(Number(params.value))}>
                        <span className="table-cell-trucate">
                            {toRupiahDesimal(Number(params.value))}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "hpp",
            headerName: "Harga Beli",
            flex: isLaptopScreen ? 1 : undefined,
            minWidth: 120,
            renderCell: (params) => {
                return (
                    <Tooltip
                        title={
                            params.value.length > 0
                                ? toRupiahDesimal(
                                      Number(
                                          params.value.slice(-1)[0].hargaBeli,
                                      ),
                                  )
                                : "-"
                        }
                    >
                        <span className="table-cell-trucate">
                            {params.value.length > 0
                                ? toRupiahDesimal(
                                      Number(
                                          params.value.slice(-1)[0].hargaBeli,
                                      ),
                                  )
                                : "-"}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "sku",
            headerName: "SKU",
            flex: isLaptopScreen ? 1 : undefined,
            minWidth: 160,
            renderCell: (params) => {
                return (
                    <Tooltip title={params.value}>
                        <span className="table-cell-trucate">
                            {params.value}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "tipe",
            headerName: "Tipe",
            flex: isLaptopScreen ? 1 : undefined,
            minWidth: 160,
            renderCell: (params) => {
                return (
                    <Tooltip title={params.value ?? "-"}>
                        <span className="table-cell-trucate">
                            {params.value ?? "-"}
                        </span>
                    </Tooltip>
                );
            },
        },
        {
            field: "aksi",
            headerName: "Aksi",
            headerAlign: "center",
            align: "center",
            minWidth: 160,
            sortable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                return (
                    // />
                    <Stack direction="row" spacing={2}>
                        <Button
                            variant="contained"
                            onClick={() =>
                                openModalPrintBarcode(
                                    params.row.sku,
                                    truncate(params.row.namaBarang, 20, true),
                                    params.row.multipleHarga.length > 0
                                        ? `Rp${toRibuan(
                                              params.row.multipleHarga[0].harga,
                                          )}`
                                        : `Rp${toRibuan(params.row.harga)}`,
                                )
                            }
                            size="small"
                            color="buttonblue"
                            disableElevation
                            sx={{
                                minWidth: "unset",
                                padding: "8px",
                                width: "32px",
                                height: "32px",
                            }}
                        >
                            <PrintIcon sx={{ width: "16px", height: "16px" }} />
                        </Button>
                        <Button
                            disabled={user && !user.akses.stok.includes(25)}
                            variant="contained"
                            onClick={() =>
                                openModal({
                                    id: params.row.id,
                                    namaBarang: params.row.namaBarang,
                                    deskripsiBarang: params.row.deskripsi,
                                    kategoriId: params.row.kategori,
                                    harga: params.row.harga,
                                    sku: params.row.sku,
                                    jumlahStok: params.row.stok,
                                    isActiveStok: params.row.isActiveStok,
                                    itemSatuan: null,
                                    isBundling: params.row.isBundling,
                                    detailBundling:
                                        dataItem?.content?.find(
                                            (li) => li.id === params.row.id,
                                        )?.detailBundling ?? [],
                                    favorite: params.row.favorite,
                                    multipleHarga: params.row.multipleHarga.map(
                                        (li: {
                                            id: number;
                                            harga: string;
                                            keterangan: string;
                                        }) => {
                                            return {
                                                id: li.id,
                                                harga: li.harga.replace(
                                                    ".",
                                                    ",",
                                                ),
                                                keterangan: li.keterangan,
                                            };
                                        },
                                    ),
                                    tipe: params.row.tipe,
                                })
                            }
                            size="small"
                            color="buttonyellow"
                            sx={{
                                minWidth: "unset",
                                padding: "8px",
                                width: "32px",
                                height: "32px",
                            }}
                        >
                            <EditIcon sx={{ width: "16px", height: "16px" }} />
                        </Button>
                        <Button
                            disabled={user && !user.akses.stok.includes(26)}
                            variant="contained"
                            onClick={() =>
                                openModalHapusStok(
                                    params.id,
                                    params.row.namaBarang,
                                )
                            }
                            size="small"
                            color="buttonred"
                            sx={{
                                minWidth: "unset",
                                padding: "8px",
                                width: "32px",
                                height: "32px",
                            }}
                        >
                            <DeleteIcon
                                sx={{ width: "16px", height: "16px" }}
                            />
                        </Button>
                    </Stack>
                );
            },
        },
    ];

    const handleOpenModalKategori = () => {
        openModalKategori();
        refetchKategori();
    };

    const handleOnPagination = (page: number) => {
        setParamsItem((prev) => ({
            ...prev,
            page: page + 1,
        }));
    };

    const handleOnSizeChange = (size: number) => {
        setParamsItem((prev) => ({ ...prev, size }));
    };

    const handleSearch = () => {
        setParamsItem((prev) => ({
            ...prev,
            search: search,
        }));
    };

    useEffect(() => {
        const timeoutId = setTimeout(
            () =>
                setParamsItem((prev) => ({
                    ...prev,
                    search: search,
                })),
            1000,
        );
        return () => clearTimeout(timeoutId);
    }, [search]);

    useEffect(() => {
        refetchItem();
    }, [dataItem, refetchItem]);

    useEffect(() => {
        refetchKategori();
    }, [dataKategori, refetchKategori]);

    useEffect(() => {
        if (isFetchingItems === true) {
            refetchItem();
            refetchKategori();
            cancelFetchingItems();
        }
    }, [cancelFetchingItems, isFetchingItems, refetchItem, refetchKategori]);

    useEffect(() => {
        // if (kategori !== null) {
        if (selectedKategori !== null) {
            setParamsItem((prev) => ({
                ...prev,
                // kategori: kategori,
                kategori: String(selectedKategori.id),
            }));
        } else {
            setParamsItem((prev) => ({
                ...prev,
                kategori: "",
            }));
        }
    }, [selectedKategori]);

    useEffect(() => {
        if (ukmIdUser) {
            setParamsItem((prev) => ({
                ...prev,
                ukmId: ukmIdUser && ukmIdUser[0],
            }));
            setParamsKategori((prev) => ({
                ...prev,
                ukmId: ukmIdUser && ukmIdUser[0],
            }));
        }
    }, [ukmIdUser]);

    // const isLoading = statusKategori === "loading" || statusItem === "loading";

    if (statusKategori === "loading") {
        return (
            <Box
                position="relative"
                height={isLaptopScreen ? "100vh" : "calc(100vh - 56px)"}
            >
                <Spinner />
            </Box>
        );
    }

    return (
        <React.Fragment>
            {isPhoneScreen ? (
                <Stack
                    display="flex"
                    justifyContent="space-between"
                    direction={{ xs: "column", sm: "row", md: "row" }}
                >
                    <Stack
                        my={2}
                        direction="row"
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                    >
                        <Typography fontSize="h6" fontWeight="bold">
                            Daftar Stok
                        </Typography>
                        <Box
                            display="flex"
                            alignItems="center"
                            gap={2}
                            flexDirection="row"
                        >
                            <Button
                                disabled={user && !user.akses.stok.includes(21)}
                                variant="contained"
                                onClick={() => openModal()}
                                sx={{ objectFit: "contain" }}
                                startIcon={<AddIcon />}
                            >
                                Tambah
                            </Button>
                        </Box>
                    </Stack>
                    <Stack
                        display="flex"
                        justifyContent="space-between"
                        direction="row"
                        spacing={1}
                    >
                        <Button
                            variant="outlined"
                            onClick={() => openModalMutasiStok()}
                            // size="small"
                            sx={{
                                backgroundColor: "#ffffff",
                                objectFit: "contain",
                            }}
                        >
                            <SearchIcon />
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => openModalKatalog()}
                            // size="small"
                            sx={{
                                backgroundColor: "#ffffff",
                                objectFit: "contain",
                            }}
                        >
                            <AssignmentReturnedIcon />
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => openModalImport()}
                            // size="small"
                            sx={{
                                backgroundColor: "#ffffff",
                                objectFit: "contain",
                            }}
                        >
                            <FileUploadIcon />
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => openModalImportHarga()}
                            // size="small"
                            sx={{
                                backgroundColor: "#ffffff",
                                objectFit: "contain",
                            }}
                        >
                            <SellIcon />
                        </Button>
                        <LoadingButton
                            loading={isLoadingButton}
                            loadingPosition="center"
                            variant="outlined"
                            onClick={downloadExportStok}
                            // size="small"
                            sx={{
                                backgroundColor: "#ffffff",
                                objectFit: "contain",
                            }}
                        >
                            <DownloadIcon />
                        </LoadingButton>
                        <Button
                            variant="outlined"
                            onClick={handleOpenModalKategori}
                            // size="small"
                            sx={{
                                backgroundColor: "#ffffff",
                                objectFit: "contain",
                            }}
                        >
                            <SettingsIcon />
                        </Button>
                    </Stack>
                </Stack>
            ) : isTabletScreen ? (
                <Stack
                    display="flex"
                    justifyContent="space-between"
                    marginTop={2}
                    direction={{ xs: "column", sm: "row", md: "row" }}
                >
                    <Typography variant="h6" fontWeight="bold">
                        Daftar Stok
                    </Typography>
                    <Stack
                        display="flex"
                        justifyContent="space-around"
                        direction="row"
                        spacing={1}
                    >
                        <Button
                            disabled={user && !user.akses.stok.includes(22)}
                            variant="outlined"
                            onClick={() => openModalMutasiStok()}
                            size="small"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            <MoveToInboxIcon />
                        </Button>
                        <Button
                            disabled={user && !user.akses.stok.includes(23)}
                            variant="outlined"
                            onClick={() => openModalKatalog()}
                            size="small"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            <AssignmentReturnedIcon />
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => openModalImport()}
                            size="small"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            {/* <LogoTokped /> */}
                            <FileUploadIcon />
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => openModalImportHarga()}
                            size="small"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            {/* <LogoTokped /> */}
                            <SellIcon />
                        </Button>
                        <LoadingButton
                            loading={isLoadingButton}
                            loadingPosition="center"
                            variant="outlined"
                            onClick={downloadExportStok}
                            size="small"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            {/* <LogoTokped /> */}
                            <DownloadIcon />
                        </LoadingButton>
                        <Button
                            disabled={user && !user.akses.stok.includes(24)}
                            variant="outlined"
                            onClick={handleOpenModalKategori}
                            size="small"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            <SettingsIcon />
                        </Button>
                    </Stack>
                </Stack>
            ) : (
                <Stack
                    display="flex"
                    justifyContent="space-between"
                    direction={{ xs: "column", sm: "row", md: "row" }}
                    marginTop={2}
                >
                    <Typography variant="h6" fontWeight="bold">
                        Daftar Stok
                    </Typography>
                    <Stack direction="row" spacing={{ xs: 0, sm: 1 }}>
                        <Button
                            disabled={user && !user.akses.stok.includes(22)}
                            variant="outlined"
                            onClick={() => openModalMutasiStok()}
                            startIcon={<MoveToInboxIcon />}
                            size="medium"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            Mutasi Stok
                        </Button>
                        <Button
                            disabled={user && !user.akses.stok.includes(23)}
                            variant="outlined"
                            onClick={() => openModalKatalog()}
                            startIcon={<AssignmentReturnedIcon />}
                            size="medium"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            Buat Katalog
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => openModalImport()}
                            startIcon={<FileUploadIcon />}
                            size="medium"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            Unggah Stok
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => openModalImportHarga()}
                            startIcon={<SellIcon />}
                            size="medium"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            Koreksi Harga
                        </Button>
                        <LoadingButton
                            loading={isLoadingButton}
                            loadingPosition="center"
                            variant="outlined"
                            onClick={downloadExportStok}
                            startIcon={<DownloadIcon />}
                            size="medium"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            Unduh Stok
                        </LoadingButton>
                        <Button
                            disabled={user && !user.akses.stok.includes(24)}
                            variant="outlined"
                            onClick={handleOpenModalKategori}
                            startIcon={<SettingsIcon />}
                            size="medium"
                            sx={{ backgroundColor: "#ffffff" }}
                        >
                            Atur Kategori
                        </Button>
                    </Stack>
                </Stack>
            )}
            <Box alignItems="center" marginY={2}>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    spacing={2}
                    alignItems="center"
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={4} md={3}>
                            <TextField
                                placeholder="Cari barang..."
                                size="small"
                                value={search}
                                onChange={(
                                    event: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                    setSearch(event.target.value);
                                }}
                                onKeyPress={(e) => {
                                    const element =
                                        e.target as HTMLInputElement;
                                    if (e.key === "Enter") {
                                        setParamsItem((prev) => ({
                                            ...prev,
                                            search: element.value,
                                            page: 1,
                                        }));
                                    }
                                }}
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleSearch}>
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                    style: {
                                        backgroundColor: "white",
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={9} sm={4} md={4} lg={4} xl={2}>
                            <Autocomplete
                                options={dataKategori?.content ?? []}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Kategori"
                                        variant="outlined"
                                    />
                                )}
                                getOptionLabel={(option) => option.nama}
                                size="small"
                                fullWidth
                                value={selectedKategori}
                                onChange={(
                                    _event,
                                    newKategori: IOptions | null,
                                ) => {
                                    setSelectedKategori(newKategori);
                                }}
                            />
                        </Grid>
                        <Grid item xs={3} sm={1}></Grid>
                    </Grid>
                    <Box
                        display={{ xs: "none", sm: "flex" }}
                        alignItems="center"
                        gap={2}
                        flexDirection="row"
                    >
                        <Button
                            disabled={user && !user.akses.stok.includes(21)}
                            variant="contained"
                            onClick={() => openModal()}
                            startIcon={<AddIcon />}
                            size="medium"
                            // fullWidth
                            sx={{
                                lineHeight: 2,
                            }}
                        >
                            Tambah
                        </Button>
                    </Box>
                </Stack>
            </Box>
            {/* <ThemeProvider theme={theme}> */}
            {isPhoneScreen || isTabletScreen ? (
                dataItem && dataItem.totalElements > 0 ? (
                    <React.Fragment>
                        {dataItem.content.map((items) => (
                            <CardStokBarang
                                key={items.id}
                                id={items.id}
                                sku={items?.sku}
                                namaBarang={items.namaBarang}
                                jumlahStok={items.stok}
                                deskripsi={items.deskripsi}
                                harga={items.harga}
                                url={items.gambar}
                                kategori={items.kategori.nama}
                                kategoriId={items.kategori}
                                isActiveStok={items.isActiveStok}
                                itemSatuan={items.itemSatuan}
                                isBundling={items.isBundling}
                                detailBundling={items.detailBundling}
                                favorite={items.favorite === 1 ? true : false}
                                multipleHarga={items.multipleHarga}
                                tipe={items.tipe}
                            />
                        ))}
                        <Box
                            display="flex"
                            justifyContent="center"
                            paddingY={2}
                        >
                            <Pagination
                                color="primary"
                                count={Math.ceil(
                                    Number(
                                        dataItem &&
                                            dataItem?.totalElements /
                                                initialParamsItem.size,
                                    ),
                                )}
                                page={paramsItem.page}
                                onChange={(event, value) => {
                                    setParamsItem((prev) => ({
                                        ...prev,
                                        page: value,
                                    }));
                                }}
                                siblingCount={0}
                                // sx={{ justifyContent: "center" }}
                            />
                        </Box>
                    </React.Fragment>
                ) : (
                    <Stack
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                        paddingTop={2}
                    >
                        <BarangTidakDitemukan width="150px" height="150px" />
                        <Typography fontWeight="bold">
                            Barang tidak ditemukan
                        </Typography>
                    </Stack>
                )
            ) : (
                <Box
                    sx={{
                        // height: "80vh",
                        height: 820,
                        width: "100%",
                        marginBottom: 3,
                        backgroundColor: "#ffffff",
                        borderRadius: 1,
                        "& .MuiDataGrid-cell:focus-within": {
                            outline: "none !important",
                        },
                        "& .MuiDataGrid-iconButtonContainer": {
                            visibility: "visible",
                            width: "0 !important",
                        },
                    }}
                >
                    <DataGrid
                        pagination
                        components={{
                            ColumnUnsortedIcon: () => {
                                return <ImportExportIcon />;
                            },
                            NoRowsOverlay: NoRowsImage,
                            LoadingOverlay: LoadingTabel,
                            // Pagination: CustomPagination,
                        }}
                        rows={
                            dataItem?.content.map((item, index) => ({
                                ...item,
                                idx: index + 1,
                            })) ?? []
                        }
                        columns={columns}
                        disableColumnMenu
                        disableSelectionOnClick
                        paginationMode="server"
                        // rowsPerPageOptions={[10, 15, 20]}
                        rowsPerPageOptions={[10]}
                        onPageSizeChange={handleOnSizeChange}
                        onPageChange={handleOnPagination}
                        rowCount={dataItem?.totalElements ?? 0}
                        page={paramsItem.page - 1}
                        pageSize={paramsItem.size}
                        loading={isLoadingItem}
                        density="comfortable"
                    />
                </Box>
            )}
            <ModalStok
                refetchItem={refetchItem}
                refetchKategori={refetchKategori}
            />
            <ModalDeleteStok refetch={refetchItem} />
            <ModalDetailBarang />
            <ModalMutasiStok />
            <ModalDetailHarga
                open={isOpenModalDetailHarga}
                onClose={closeModalDetailHarga}
                data={selectedBarang}
            />
            <ModalImportHarga
                isOpenModalImportHarga={isOpenModalImportHarga}
                closeModalImportHarga={closeModalImportHarga}
            />
            {/* </ThemeProvider> */}
        </React.Fragment>
    );
};

export default TabelBarang;
